import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import apiServices from 'api_services/request-handler';
import { setAuditLoading, setAudits, setDeleteLoading, setAuditDetail } from '../slices/audits-slice';

export const getAudits = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getAudits,
        setLoading: setAuditLoading,
        param_data: params,
        setData: setAudits,
      }),
    );
  };
};

export const getAuditById = (params: any) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getAuditsById,
        setLoading: setAuditLoading,
        param_data: params,
        setData: setAuditDetail,
      }),
    );
  };
};

export const deleteAudit = (params: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.deleteAudit,
        setLoading: setDeleteLoading,
        param_data: params,
        isSuccessMessage: true,
        onDone: (data: any) => onDone && onDone(),
      }),
    );
  };
};

export const createAudit = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.createAudit,
        setLoading: setAuditLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: (data: any) => onDone && onDone(),
      }),
    );
  };
};

export const editAudit = (data: any, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.editAudit,
        setLoading: setAuditLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: (data: any) => onDone && onDone(),
      }),
    );
  };
};
